// removed by extract-text-webpack-plugin
module.exports = {"container":"_3xQPGyy2W0PJZt0GSqJ4eA","item":"_2Ev303WdFjTPnWH1uN0Hiz"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/login/pages/LoginPage.scss
// module id = 662
// module chunks = 0